<template>
  <div class="container">
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" rel="stylesheet">
    <div class="card shadow-sm">
      <div class="card-body position-relative">
        <h4 class="card-title mb-3">{{$t('FeedbackTitle')}}</h4>

        <div class="position-relative" style="min-height: 300px">
          <!-- Step 1: Overall Quality -->
          <div class="step active" id="step1">
            <p>{{$t('RateTitle')}}</p>
            <div class="mb-3 star-rating text-warning" id="starRating">
              <star-rating v-model="starRating"></star-rating>
            </div>
          </div>

          <!-- Step 2: Time Saved -->
          <div class="step" id="step2">
            <p>{{$t('SaveTimeTitle')}}</p>
            <p class="text-muted small mb-3">{{$t('SaveTimeDescription')}}</p>
            <div class="btn-group mb-3" role="group" id="timeSavedGroup">
              <input type="radio" v-model="savedTime" class="btn-check" name="timeSaved" id="timeYes" :value='true' autocomplete="off">
              <label class="btn btn-outline-success" for="timeYes">{{$t('Yes')}}</label>

              <input type="radio" v-model="savedTime" class="btn-check" name="timeSaved" id="timeNo" :value='false' autocomplete="off">
              <label class="btn btn-outline-secondary" for="timeNo">{{$t('No')}}</label>
            </div>
            
            <div v-if="savedTime" class="mb-3">
              <p>{{$t('SaveTimeApproxTitle')}}</p>
              <p class="text-muted small mb-3">{{$t('SaveTimeApproxDescription')}}</p>
              <div class="btn-group" role="group">
                <input type="radio" v-model="timeSaved" class="btn-check" name="roughTime" id="time1" value="0.5" autocomplete="off">
                <label class="btn btn-outline-info" for="time1">{{$t('LessThanAnHour')}}</label>

                <input type="radio" v-model="timeSaved" class="btn-check" name="roughTime" id="time2" value="1.5" autocomplete="off">
                <label class="btn btn-outline-info" for="time2">{{$t('OneToTwoHours')}}</label>

                <input type="radio" v-model="timeSaved" class="btn-check" name="roughTime" id="time3" value="3" autocomplete="off">
                <label class="btn btn-outline-info" for="time3">{{$t('TwoToFourHours')}}</label>

                <input type="radio" v-model="timeSaved" class="btn-check" name="roughTime" id="time4" value="5" autocomplete="off">
                <label class="btn btn-outline-info" for="time4">{{$t('MoreThanFourHours')}}</label>

                <input type="radio" v-model="timeSaved" class="btn-check" name="roughTime" id="timeUnknown" value="0" autocomplete="off">
                <label class="btn btn-outline-secondary" for="timeUnknown">{{$t('NotSure')}}</label>
              </div>
            </div>
          </div>

          <!-- Step 3: Prior Knowledge -->
          <div class="step" id="step3">
            <p>{{$t('AlreadyKnowHowTitle')}}</p>
            <p class="text-muted small mb-3">{{$t('AlreadyKnowHowDescription')}}</p>
            <div class="btn-group mb-3" role="group" id="knewAlreadyGroup">
              <input type="radio" v-model="wasKnownBefore" class="btn-check" name="knewIt" id="knewYes" :value='true' autocomplete="off">
              <label class="btn btn-outline-primary" for="knewYes">{{$t('Yes')}}</label>

              <input type="radio" v-model="wasKnownBefore" class="btn-check" name="knewIt" id="knewNo" :value='false' autocomplete="off">
              <label class="btn btn-outline-primary" for="knewNo">{{$t('No')}}</label>
            </div>

            <div v-if="wasKnownBefore" class="mb-3">
              <p>{{$t('DocumentationBetterTitle')}}</p>
              <div class="btn-group" role="group">
                <input type="radio" v-model="betterThanKnown" class="btn-check" name="betterDoc" id="betterYes" :value='true' autocomplete="off">
                <label class="btn btn-outline-success" for="betterYes">{{$t('Yes')}}</label>

                <input type="radio" v-model="betterThanKnown" class="btn-check" name="betterDoc" id="betterNo" :value='false' autocomplete="off">
                <label class="btn btn-outline-secondary" for="betterNo">{{$t('No')}}</label>
              </div>
            </div>
          </div>

          <!-- Step 4: Additional Metrics -->
          <div class="step" id="step4">
            <p>{{$t('RecommendSOPTitle')}}</p>
            <p class="text-muted small mb-3">{{$t('RecommendSOPDescriptiion')}}</p>
            <div class="btn-group mb-3" role="group">
              <input type="radio" v-model="wouldRecommend" class="btn-check" name="recommend" id="recommendYes" :value='true' autocomplete="off">
              <label class="btn btn-outline-success" for="recommendYes">{{$t('Yes')}}</label>

              <input type="radio" v-model="wouldRecommend" class="btn-check" name="recommend" id="recommendNo" :value='false' autocomplete="off">
              <label class="btn btn-outline-secondary" for="recommendNo">{{$t('No')}}</label>
            </div>

            <p>{{$t('SOPEasyToFollowTitle')}}</p>
            <div class="btn-group" role="group">
              <input type="radio" v-model="easyToFollow" class="btn-check" name="easyFollow" id="easyYes" :value='true' autocomplete="off">
              <label class="btn btn-outline-success" for="easyYes">{{$t('Yes')}}</label>

              <input type="radio" v-model="easyToFollow" class="btn-check" name="easyFollow" id="easyNo" :value='false' autocomplete="off">
              <label class="btn btn-outline-secondary" for="easyNo">{{$t('No')}}</label>
            </div>
          </div>

          <!-- Step 5: Optional Comments -->
          <div class="step" id="step5">
            <label for="feedbackText" class="form-label">{{$t('CommentsTitle')}}</label>
            <p class="text-muted small mb-3">{{$t('CommentsDescription')}}</p>
            <textarea v-model="comment" class="form-control" id="feedbackText" rows="3" :placeholder="$t('CommentTextAreaPlaceholder')"></textarea>
          </div>
        </div>

        <!-- Fixed Footer for Navigation -->
        <div class="mt-4 pt-3 border-top">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex gap-2">
              <!-- Step 1 -->
              <div class="step-buttons" id="step1-buttons">
                <button class="btn btn-secondary" @click='nextStep(2)'>{{$t('Next')}}</button>
              </div>

              <!-- Step 2 -->
              <div class="step-buttons" id="step2-buttons" style="display: none">
                <button class="btn btn-outline-secondary" @click="prevStep(1)">{{$t('Back')}}</button>
                <button class="btn btn-secondary" @click="nextStep(3)">{{$t('Next')}}</button>
              </div>

              <!-- Step 3 -->
              <div class="step-buttons" id="step3-buttons" style="display: none">
                <button class="btn btn-outline-secondary" @click="prevStep(2)">{{$t('Back')}}</button>
                <button class="btn btn-secondary" @click="nextStep(4)">{{$t('Next')}}</button>
              </div>

              <!-- Step 4 -->
              <div class="step-buttons" id="step4-buttons" style="display: none">
                <button class="btn btn-outline-secondary" @click="prevStep(3)">{{$t('Back')}}</button>
                <button class="btn btn-secondary" @click="nextStep(5)">{{$t('Next')}}</button>
              </div>

              <!-- Step 5 -->
              <div class="step-buttons" id="step5-buttons" style="display: none">
                <button class="btn btn-outline-secondary" @click="prevStep(4)">{{$t('Back')}}</button>
              </div>
            </div>

            <button class="btn btn-primary"
                    @click="SubmitFeedback()"
                    :disabled="starRating === 0"
                    :class="{ 'opacity-50': starRating === 0 }">
              {{$t('SubmitFeedback')}}
            </button>
          </div>
        </div>

        <div id="feedbackResult" class="mt-3 text-success d-none">Thank you! Feedback submitted.</div>
      </div>
    </div>
  </div>
</template>


<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import StarRating from 'vue-star-rating'

  export default {
    data() {
      return {
        starRating: 0,
        savedTime: null,
        wasKnownBefore: null,
        betterThanKnown: null,
        wouldRecommend: null,
        easyToFollow: null,
        timeSaved: 0,
        comment: ""
      }

    },
    components: {
      StarRating
    },
    props: ["shareObjectId"],
    methods: {
      nextStep(n) {
        const steps = document.querySelectorAll('.step');
        const buttons = document.querySelectorAll('.step-buttons');
        
        steps.forEach((el, i) => {
          el.classList.remove('active');
        });
        buttons.forEach((el, i) => {
          el.style.display = 'none';
        });
        
        requestAnimationFrame(() => {
          document.getElementById('step' + n).classList.add('active');
          document.getElementById('step' + n + '-buttons').style.display = 'flex';
        });
      },
      prevStep(n) {
        const steps = document.querySelectorAll('.step');
        const buttons = document.querySelectorAll('.step-buttons');
        
        steps.forEach((el, i) => {
          el.classList.remove('active');
        });
        buttons.forEach((el, i) => {
          el.style.display = 'none';
        });
        
        requestAnimationFrame(() => {
          document.getElementById('step' + n).classList.add('active');
          document.getElementById('step' + n + '-buttons').style.display = 'flex';
        });
      },
      SubmitFeedback() {
        if (this.starRating === 0) {
          this.$vs.notify({
            title: "Please provide a rating",
            text: "At least a 1-star rating is required to submit feedback.",
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
          return;
        }

        var instance = this;
        const query = `
          mutation SaveFeedback(
            $id:Int!,
            $wasArticleHelpful:Boolean!,
            $wasAlreadyKnown:Boolean!,
            $betterThanKnown:Boolean,
            $wouldRecommend:Boolean,
            $easyToFollow:Boolean,
            $comment:String,
            $rating:Decimal!,
            $didArticleSaveTime:Boolean!,
            $timeSaved:Decimal!,
            $onboardingId:Int!
          ) {
            saveFeedback(
              feedback: {
                id: $id
                wasArticleHelpful: $wasArticleHelpful
                wasAlreadyKnown: $wasAlreadyKnown
                betterThanKnown: $betterThanKnown
                wouldRecommend: $wouldRecommend
                easyToFollow: $easyToFollow
                didArticleSaveTime: $didArticleSaveTime
                timeSaved: $timeSaved
                comment: $comment
                onboardingId: $onboardingId
                rating: $rating
              }
            )
          }
        `;

        const variables = {
          id: 0,
          wasArticleHelpful: this.starRating > 3,
          wasAlreadyKnown: this.wasKnownBefore,
          betterThanKnown: this.betterThanKnown,
          wouldRecommend: this.wouldRecommend,
          easyToFollow: this.easyToFollow,
          rating: this.starRating,
          onboardingId: this.shareObjectId * 1,
          didArticleSaveTime: this.savedTime,
          comment: this.comment,
          timeSaved: this.timeSaved * 1
        };

        const payload = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", payload, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: "Thank you for your feedback!",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.$emit('CloseFeedback')
          }
        }).catch(err => {
          instance.$vs.notify({
            title: "A problem occurred while attempting to save your feedback.",
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },
    },
  }

</script>

<style>
  .star-rating .fa-star {
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }

  .thumb {
    font-size: 1.5rem;
    cursor: pointer;
    transition: transform 0.2s ease;
  }

    .thumb:hover {
      transform: scale(1.2);
    }

  .step-buttons {
    display: flex;
    gap: 0.5rem;
  }

  .step {
    display: none;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.3s ease-in-out;
    position: absolute;
    width: 100%;
  }

    .step.active {
      display: block;
      opacity: 1;
      transform: translateY(0);
      position: relative;
    }

  .opacity-50 {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
